import { FC, Fragment } from 'react';

import { ADTO } from '@helpful/network';
import { Typography, Badge } from '@wearehelpful/ui-kit';
import { useDate, useTranslation } from '@wearehelpful/ui-localization';

import { Badges } from './ToDoCardContent.style';

export const ToDoCardContent: FC<ADTO.TodoLocalizedEntity> = ({
  encounter,
  shortDescription,
}) => {
  const { format } = useDate();
  const { t } = useTranslation();

  if (!!encounter) {
    return (
      <Fragment>
        {!!encounter?.date && (
          <Typography variant="p2">
            {format({ value: encounter.date, format: 'LLLL' })}
          </Typography>
        )}
        {!!encounter?.location && (
          <Typography variant="p2">{encounter.location}</Typography>
        )}
        {!!encounter?.provider && (
          <Typography variant="p2">
            {[
              encounter?.provider?.prefix,
              encounter?.provider?.firstName,
              encounter?.provider?.lastName,
              encounter?.provider?.suffix,
            ].join(' ')}
          </Typography>
        )}
        <Badges>
          {!!encounter?.connection && (
            <Badge variant="primary">
              {encounter?.connection?.system?.name}
            </Badge>
          )}
          {!!encounter?.careplan?.description && (
            <Badge variant="secondary">{t('forms.afterVisitSummary')}</Badge>
          )}
        </Badges>
      </Fragment>
    );
  }

  return <>{shortDescription}</>;
};
